<template>
  <AulaTemplate
    :titulo="$store.state.topicos[1].titulo"
    :numero="$store.state.topicos[1].numero"
    titleSize="5"
  >
    <TextBlock animation="zoom-in">
      <div class="youtube-container" style="max-width: 600px">
        <youtube
          video-id="Xwu_unXbqAo"
          class="mt-8 elevation-10"
          style="border: solid 3px white"
          fit-parent
        />
      </div>
    </TextBlock>

    <v-row justify="center" class="mt-5">
      <v-col cols="12" lg="7">
        <Imagem src="modulo_02/frase_balao_4.svg" />
      </v-col>
    </v-row>

    <TextBlock
      subTopico="2.1 A ORDEM DE PREVALÊNCIA NO TRÂNSITO E OS TIPOS DE SINALIZAÇÃO VIÁRIA"
    >
      <Paragraph>
        Compreender e seguir a ordem de prevalência é fundamental para garantir
        que as regras de trânsito sejam aplicadas corretamente e que a segurança
        nas vias seja mantida. De acordo com o Artigo 89 do Código de Trânsito
        Brasileiro (CTB), a sinalização deve seguir a seguinte ordem de
        prevalência (CTB, 1997):
      </Paragraph>
    </TextBlock>

    <v-row justify="center" class="mt-5">
      <v-col cols="12" lg="7">
        <Imagem
          legenda="Imagem 4: Ordem de prevalência na sinalização do trânsito"
          src="modulo_02/piramide.svg"
          fonte="CTB, 1997"
        />
      </v-col>
    </v-row>

    <TextBlock>
      <Paragraph>
        A ordem de prevalência define qual sinal ou indicação deve ser
        respeitado em diferentes situações, ajudando a evitar conflitos e
        confusões no trânsito.
      </Paragraph>

      <Paragraph>
        Agora, que tal explorarmos os diferentes tipos de sinalização viária?
        Conhecer e entender cada tipo de sinalização é essencial para aplicar
        corretamente as regras de trânsito e garantir a segurança nas vias. A
        sinalização viária inclui sinais de regulamentação, advertência e
        indicação, cada um com uma função específica para orientar e informar
        condutores e pedestres. Compreender essas categorias e como elas se
        aplicam na prática ajuda a manter a ordem no trânsito e a evitar
        confusões.
      </Paragraph>
    </TextBlock>

    <TextBlock subTopico="2.1.1 Sinalização Vertical">
      <div class="youtube-container" style="max-width: 600px">
        <youtube
          video-id="-DmYFPyU4VI"
          class="mt-8 elevation-10"
          style="border: solid 3px white"
          fit-parent
        />
      </div>

      <Paragraph>
        As placas de trânsito, conhecidas como sinalização vertical, são
        fundamentais para a regulamentação e orientação no trânsito. Elas podem
        ser classificadas em três tipos principais:
      </Paragraph>
    </TextBlock>

    <v-row justify="center" class="mt-5">
      <v-col cols="12" lg="8">
        <Imagem
          src="modulo_02/placas-transito.png"
          fonte="BRASIL, 2022."
          legenda="Quadro 2 : Classificação das placas de trânsito"
        />
      </v-col>
    </v-row>

    <TextBlock subTopico="2.1.3  Sinalização Horizontal">
      <Paragraph>
        A sinalização horizontal é composta por marcas e pinturas no solo que
        orientam o fluxo de veículos e pedestres nas vias. Ela inclui linhas,
        faixas e símbolos que definem a circulação, delimitam faixas de
        rolamento e áreas de travessia, além de indicar regras de ultrapassagem.
        Esses elementos são fundamentais para a organização do trânsito e para a
        segurança de todos os usuários das vias.
      </Paragraph>

      <Paragraph>
        Vamos explorar mais sobre os diferentes tipos de sinalização horizontal
        e suas funções para garantir que você esteja bem informado e preparado
        para dirigir com segurança.
      </Paragraph>
    </TextBlock>

    <TextBlock>
      <Accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>Pinturas no Solo</v-expansion-panel-header>
          <v-expansion-panel-content>
            As marcas na pista, como linhas, faixas de pedestres, setas e outros
            símbolos, são essenciais para orientar o fluxo de trânsito e definir
            áreas de circulação.
            <v-row justify="center" class="mt-8">
              <v-col cols="12" lg="6">
                <Imagem src="modulo_02/Pinturas-no-solo.png" />
                <div
                  class="black--text font-weight-light text-center"
                  style="line-height: 1rem; font-size: 0.75rem"
                >
                  Fonte: Imagem gerada por IA
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Faixas</v-expansion-panel-header>
          <v-expansion-panel-content>
            Dividem os sentidos da via, delimitam faixas de rolamento e áreas de
            travessia de pedestres.

            <v-row class="mt-8">
              <v-col cols="12" lg="6">
                <strong>Pista com faixa seccionada</strong>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-8">
              <v-col cols="12" lg="6">
                <Imagem src="modulo_02/Pista-com-faixa-seccionada.png" />
                <div
                  class="black--text font-weight-light text-center"
                  style="line-height: 1rem; font-size: 0.75rem"
                >
                  Fonte: Imagem gerada por IA
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-8">
              <v-col cols="12" lg="6">
                <strong>Pista com faixa contínua</strong>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-8">
              <v-col cols="12" lg="6">
                <Imagem src="modulo_02/Faixa-continua.png" />
                <div
                  class="black--text font-weight-light text-center"
                  style="line-height: 1rem; font-size: 0.75rem"
                >
                  Fonte: Imagem gerada por IA
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </Accordion>
    </TextBlock>

    <BoxIcon tipo="voce_sabia">
      Para uma compreensão mais detalhada sobre a sinalização horizontal e as
      faixas pintadas nas vias, assista ao vídeo que oferece uma explicação
      visual sobre as diferentes marcações no solo e suas funções essenciais no
      tráfego:
      <a
        style="color: white"
        href="https://youtu.be/2EV1vdEIWFU"
        target="_blank"
        >https://youtu.be/2EV1vdEIWFU</a
      >
    </BoxIcon>

    <TextBlock>
      <Paragraph>
        Você já sabe que a sinalização horizontal desempenha um papel
        fundamental na orientação e regulamentação do fluxo de tráfego. Entre as
        marcas mais importantes estão as linhas de marcação, conhecidas como LM,
        que são usadas para delimitar faixas de rolamento, separar sentidos de
        tráfego e indicar regras específicas para a ultrapassagem. Vamos
        conhecer as principais linhas de marcação:
      </Paragraph>
    </TextBlock>

    <Faixas />

    <TextBlock>
      <Audio_1 />
    </TextBlock>

    <TextBlock>
      <Paragraph>
        Vejamos a seguir como essas marcas organizam a circulação e segurança de
        forma abrangente, funcionando como uma orientação visual que ajuda a
        manter o fluxo e a organização do tráfego. Agora, que tal testar seus
        conhecimentos? Arraste cada imagem de marcação viária para a descrição
        correta de seu uso!
      </Paragraph>
    </TextBlock>

    <TextBlock>
      <v-row>
        <v-col cols="12" md="4">
          <FlipCardImg bgImg="modulo_01/marca1.png">
            <template #front>Marcas Longitudinais</template>

            <template #back>
              Separam e ordenam as correntes de tráfego, definindo e parte da
              pista destinada normalmente circulação de veículos, a sua divisão
              em faixas reversíveis, a separação de fluxos opostos, faixas de
              uso exclusivo de um tipo de veículo, além de estabelecer as regras
              de ultrapassagem e transposição.
            </template>
          </FlipCardImg>
        </v-col>

        <v-col cols="12" md="4">
          <FlipCardImg bgImg="modulo_01/marca2.png">
            <template #front>Marcas Transversais</template>

            <template #back>
              Ordenam os deslocamentos frontais dos veículos e os harmonizam com
              os deslocamentos de outros veículos e dos pedestres, assim como
              informam os condutores sobre a necessidade de reduzir a velocidade
              e indicam travessia de pedestres e posições de parada.
            </template>
          </FlipCardImg>
        </v-col>

        <v-col cols="12" md="4">
          <FlipCardImg bgImg="modulo_01/marca3.jpeg">
            <template #front>Marcas de Canalização</template>

            <template #back>
              Orientam os fluxos de tráfego em uma via, direcionando a
              circulação de veículos. Regulamentam as áreas de pavimento não
              utilizáveis.
            </template>
          </FlipCardImg>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <FlipCardImg bgImg="modulo_01/marca4.jpeg">
            <template #front
              >Marcas de delimitação e controle de estacionamento e/ou
              parada</template
            >

            <template #back>
              Delimitam e propiciam melhor controle das áreas onde é proibido ou
              regulamentado o estacionamento e a parada de veículos, quando
              associados à sinalização vertical de regulamentação. Em casos
              específicos têm poder de regulamentação.
            </template>
          </FlipCardImg>
        </v-col>

        <v-col cols="12" md="4">
          <FlipCardImg bgImg="modulo_01/marca5.jpg">
            <template #front>Inscrições no pavimento</template>

            <template #back>
              Melhoram a percepção do condutor quanto às condições de operação
              da via, permitindo-lhe tomar a decisão adequada, no tempo
              apropriado, para as situações que se apresentem.
            </template>
          </FlipCardImg>
        </v-col>
      </v-row>
    </TextBlock>

    <TextBlock subTopico="2.1.4 Outros tipos de sinalização">
      <Paragraph>
        Além da sinalização vertical e horizontal, existem outros tipos de
        sinalização que desempenham papéis cruciais na organização e segurança
        do trânsito. Esses métodos complementares são utilizados para fornecer
        informações adicionais, orientar condutores e pedestres, e assegurar a
        conformidade com as regras de trânsito em situações específicas. Vejamos
        a seguir:
      </Paragraph>

      <v-row class="my-8">
        <v-col cols="12" md="4">
          <FlipCardImg bgImg="modulo_01/flip1.png">
            <template #front>Sinalização Semafórica</template>

            <template #back>
              Os semáforos são dispositivos essenciais para o controle do fluxo
              de veículos e pedestres em cruzamentos. Eles utilizam luzes com
              cores padrão (vermelho, amarelo e verde) para fornecer instruções
              claras: parar, estar atento ou seguir, respectivamente.
            </template>
          </FlipCardImg>
        </v-col>

        <v-col cols="12" md="4">
          <FlipCardImg bgImg="modulo_01/flip2.png">
            <template #front>Sinalização Sonora</template>

            <template #back>
              A sinalização sonora inclui sirenes e apitos, que são utilizados
              em situações específicas, como para veículos de emergência ou para
              fornecer orientações temporárias no trânsito.
            </template>
          </FlipCardImg>
        </v-col>

        <v-col cols="12" md="4">
          <FlipCardImg bgImg="modulo_01/flip3.png">
            <template #front>Sinalização de Obras e Temporária</template>

            <template #back>
              Para indicar alterações temporárias no trânsito devido a obras ou
              eventos, são empregados cones, barreiras e placas móveis. Esses
              dispositivos ajudam a gerenciar o tráfego e a garantir a segurança
              dos motoristas e pedestres durante mudanças temporárias nas
              condições das vias.
            </template>
          </FlipCardImg>
        </v-col>
      </v-row>
    </TextBlock>

    <BoxIcon tipo="recapitulando">
      Chegamos ao final do Tópico 2. Neste módulo, exploramos a importância de
      conhecer e respeitar as diferentes formas de sinalização, essenciais para
      assegurar uma circulação segura e eficiente nas vias. Compreender e
      aplicar corretamente a sinalização vertical, horizontal, semafórica,
      sonora e temporária é crucial para manter a ordem no trânsito e prevenir
      acidentes. Agora, vamos avançar para o próximo tópico, onde abordaremos os
      direitos e deveres do condutor. Prepare-se para acelerar em direção a
      novas informações!
    </BoxIcon>
  </AulaTemplate>
</template>

<script>
import AulaTemplate from "@/components/AulaTemplate.vue";
import TextBlock from "@/components/TextBlock.vue";
import Paragraph from "@/components/Paragraph.vue";
import BoxIcon from "@/components/BoxIcon.vue";
import Accordion from "@/components/Accordion.vue";
import Imagem from "@/components/Imagem.vue";
import FlipCardImg from "@/components/FlipCardImg.vue";
import Faixas from "./components/Faixas.vue";
import Audio_1 from "./audios/Audio_1.vue";

export default {
  components: {
    AulaTemplate,
    TextBlock,
    Paragraph,
    BoxIcon,
    Accordion,
    Imagem,
    FlipCardImg,
    Faixas,
    Audio_1,
  },
  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    dialogInput(value) {
      if (!value) {
        // Acessa o player do vídeo através da referência ref
        const player = this.$refs.videoPlayer.player;

        if (player && typeof player.pauseVideo === "function") {
          player.pauseVideo();
        }
      }
    },
  },

  mounted() {
    this.$store.commit("ADICIONAR_SCORE", "topico_02");
  },
};
</script>

<style scoped></style>
